
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:635)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.333 24.043V30.5H17a6.666 6.666 0 018.333-6.457zM23.667 23c-2.763 0-5-2.238-5-5s2.237-5 5-5c2.762 0 5 2.238 5 5s-2.238 5-5 5zm5 3.333v-2.5h1.666v2.5h2.5V28h-2.5v2.5h-1.666V28h-2.5v-1.667h2.5z","fill":"#28A920"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:635","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:635"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:635","result":"shape"}})])])])
          )
        }
      }
    